import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="spaces-finder-redirect"
export default class extends Controller {
  connect() {
  }

  submit() {
    console.log('submitting');
    this.element.method = 'GET';
    this.element.setAttribute("data-turbo", "false")
  }
}
